import axios from '../../../axiosConfig';

export function getLocations(config = {}, clientId) {
    return axios.get(`/v1/location/all/${clientId}`, config);
}

export function getLocationsSimple(clientId, config = {}) {
    return axios.get(`/v1/location/${clientId}/simple`, config);
}

export function getLocationById(id, config = {}) {
    return axios.get(`/v1/location/${id}`, config);
}

export function createLocation(data, config = {}) {
    return axios.post(`/v1/location`, data, config);
}

export function updateLocation(data, config = {}) {
    return axios.put(`/v1/location/${data.id}`, data, config);
}

export function deleteLocation(locationId, config = {}) {
    return axios.delete(`/v1/location/${locationId}`, config);
}

const functions = { getLocations, getLocationsSimple, getLocationById, createLocation, updateLocation, deleteLocation }
export default functions
